
<div class="text-center mt-3">
    <span class="azul2"><b>Powered by</b></span>
    <br>
    <img src="../assets/images/logo/red-pyme.jpg" height="50px">
</div>